import { render, staticRenderFns } from "./RightsHoldersList.vue?vue&type=template&id=4e83f372&"
import script from "./RightsHoldersList.vue?vue&type=script&lang=js&"
export * from "./RightsHoldersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports